import styled from "styled-components";

export const BaseDiv = styled.div`
    display: flex;
    max-width: 1000px;
    background-color: white;
    border-radius: 30px;
    margin-bottom: 2%;

`;

export const AboutUsContent = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
`;

export const TextContent = styled.div`
    color: var(--purple);
    text-align: center;
`;

export const DoubleInput = styled.div`
    display: flex;
    justify-content: center;
    @media (max-width: 900px) {
        flex-direction: column;
    }
`;
export const InputIndividual = styled.div`
    max-width: 400px;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
`;

export const TextBody = styled.div`
    font-size: 24px;
    padding: 5%;
    p {
        margin-top: 3%;
    }
`;